"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBannerImage = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for displaying image background in TopBanner. For falsy value in `imageUrl` returns `null`.
 */
const TopBannerImage = ({
  imageUrl,
  backgroundColor,
  title
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    breakpoints: {
      values: {
        sm
      }
    },
    palette
  } = (0, _mui.useTheme)();
  if (!imageUrl) {
    return null;
  }
  const imagesVariants = {
    url: imageUrl,
    backgroundColor: backgroundColor ?? palette.common.white,
    imageFormat: 'WebP',
    imageSizeMultiplier: 2,
    params: [{
      height: _constants.TOP_BANNER_MOBILE_HEIGHT,
      width: sm,
      quality: 85
    }, {
      height: _constants.TOP_BANNER_DESKTOP_HEIGHT,
      width: 1200,
      quality: 90
    }, {
      height: _constants.TOP_BANNER_DESKTOP_HEIGHT,
      width: 1920,
      quality: 95
    }],
    excludeWidthFromUrl: true
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageRoot, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Image, {
      alt: title ?? imageUrl,
      "data-testid": getTestId(_constants.TOP_BANNER_IMAGE),
      fetchPriority: "high",
      srcSet: (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)),
      sizes: `(max-width: ${sm - 1}px) ${sm}px, (max-width: 1200px) 1200px, 1920px`
    })
  });
};
exports.TopBannerImage = TopBannerImage;
//# sourceMappingURL=TopBannerImage.js.map